export default "__VITE_ASSET__CBPlFmk1__"